// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"398":"a6aad3e7","973":"ec6a7e77"}[chunkId] + ".chunk.js");